import {Button, Stack} from '@mui/material';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {MY_APPOINTMENT_DETAILS_PATH} from 'presentation/modules/myAppointments/constants/appointmentDetailsPath';
import {translations} from 'presentation/translations-new';
import {PrefixTestEnum} from 'presentation/constants/PrefixTestEnum';

import {useVoiceTranscriptionDrawerStore} from 'presentation/components/VoiceTranscriptionDrawer/store';
import {FeaturesEnum, TermsOriginEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

import {CardActionsProps} from './types';
import {ConfirmButton} from '../ConfirmButton';
import {checkConfirmAppointment} from 'presentation/utils';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
const {appointmentCard} = translations['pt-br'].privateFlow.myAppointments;

export function CardActions({appointment, showEnterRoom}: CardActionsProps) {
	const navigate = useNavigate();

	const onOpen = useVoiceTranscriptionDrawerStore(state => state.onOpen);
	const {isEnabled: isUrgencyTeleTermsEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_URGENCY_TELE_TERMS,
	);

	const isSurgery = appointment.bookingType === BookingTypeEnum.SURGERY;
	const showConfirmButton = checkConfirmAppointment(appointment.date, isSurgery);

	function handleGoToDetails() {
		navigate(
			MY_APPOINTMENT_DETAILS_PATH[appointment.bookingType].replace(
				':id',
				appointment.bookingNumber,
			),
		);
	}

	function handleOpenTelehealthRoom() {
		if (appointment.telehealthUrl) {
			if (isUrgencyTeleTermsEnabled) {
				onOpen(appointment.telehealthUrl, TermsOriginEnum.TELEHEALTH);
				return;
			}
			window.open(appointment.telehealthUrl);
		}
	}

	return (
		<Stack direction="row" gap={1} width="100%" justifyContent="flex-end" alignItems="center">
			{showEnterRoom ? (
				<Button size="medium" variant="contained" onClick={handleOpenTelehealthRoom}>
					{appointmentCard.teleHealth.goToTelehealthRoom}
				</Button>
			) : (
				<ConfirmButton appointment={appointment} />
			)}
			<Button
				variant={showConfirmButton || showEnterRoom ? 'outlined' : 'contained'}
				size="medium"
				onClick={handleGoToDetails}
				data-testid={`${PrefixTestEnum.SEE_DETAILS}${appointment.bookingType}`}>
				{appointmentCard.goToDetails}
			</Button>
		</Stack>
	);
}
